import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FilePropertiesDateFormat } from '../../constants/file-properties-date-format.constant';

/** Component for displaying general file properties. */
@Component({
  selector: 'mc-file-properties',
  templateUrl: './file-properties.component.html',
  styleUrls: ['./file-properties.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilePropertiesComponent {
  /** The size of the file. */
  @Input() size: number;
  /** When the file was last committed to Git. */
  @Input() committedAt: ISO8601DateString;
  /** Whether the file is currently being fetched from Git. */
  @Input() fetchingCommit?: boolean;
  /** Whether to show the last modified date of the file. */
  @Input() showModified?: boolean;
  /** When the file was created in the system. */
  @Input() createdAt?: ISO8601DateString;
  /** When the file was last modified. */
  @Input() modifiedAt?: ISO8601DateString;
  /** Whether to show the image properties of the file. */
  @Input() showImageProperties?: boolean;
  /** The dimensions of the image file. */
  @Input() imageDimensions?: { height: number, width: number };
  /** The resolution of the image file. */
  @Input() imageResolution?: { x: number, y: number };

  FilePropertiesDateFormat: string = FilePropertiesDateFormat;

  /** The last modified date of the file. */
  get modified(): string {
    if (this.modifiedAt)
      return this.modifiedAt;
    // the file document may be created through a commit or by adding to collab system
    return this.committedAt ?? this.createdAt;
  }
}
